import { useSyncExternalStore } from 'react';

/**
 * Reactive `matchMedia` check. `ResponsiveDialog` uses it to pick Dialog vs
 * Drawer. The server snapshot is `false` (there is no SSR, but the signature
 * stays honest).
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (callback) => {
      const mediaQuery = window.matchMedia(query);
      mediaQuery.addEventListener('change', callback);
      return () => mediaQuery.removeEventListener('change', callback);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
